import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRestriction = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "restriction",
	"data-name": "restriction",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon square-linecap",
			d: "M1.46,12.94H8.17a0,0,0,0,1,0,0v.73a3.11,3.11,0,0,1-3.11,3.11h-.5a3.11,3.11,0,0,1-3.11-3.11v-.73A0,0,0,0,1,1.46,12.94Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M.5,5.27H5.92a3.18,3.18,0,0,0,2.29-1h0a3.24,3.24,0,0,1,2.29-1h3a3.27,3.27,0,0,1,2.31,1h0a3.27,3.27,0,0,0,2.32,1H23.5"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 12,
			y1: .48,
			x2: 12,
			y2: 22.52
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 17.75,
			y1: 22.52,
			x2: 6.25,
			y2: 22.52
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "plan2plate-icon square-linecap",
			points: "5.29 5.27 4.33 5.27 1.46 11.98 1.46 12.94 8.17 12.94 8.17 11.98 5.29 5.27"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon square-linecap",
			d: "M15.83,12.94h6.71a0,0,0,0,1,0,0v.73a3.11,3.11,0,0,1-3.11,3.11h-.5a3.11,3.11,0,0,1-3.11-3.11v-.73a0,0,0,0,1,0,0Z"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "plan2plate-icon square-linecap",
			points: "19.67 5.27 18.71 5.27 15.83 11.98 15.83 12.94 22.54 12.94 22.54 11.98 19.67 5.27"
		})
	]
});
const ForwardRef = forwardRef(SvgRestriction);
export default ForwardRef;
